import { useState } from 'react';

export type TriggerProps = {
  role: string;
  'aria-expanded': boolean;
  'aria-controls': string;
};

export type UseDisclosureResponse = {
  isOpen: boolean;
  triggerProps: TriggerProps;
  toggle: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

export function useDisclosure(
  defaultOpen: boolean,
  contentId: string
): UseDisclosureResponse {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return {
    isOpen: isOpen,
    setIsOpen,
    toggle: () => {
      setIsOpen((isOpen) => !isOpen);
    },
    triggerProps: {
      role: 'button',
      'aria-expanded': isOpen,
      'aria-controls': contentId,
    },
  };
}

export default useDisclosure;
